// components/StudentPortal/Exam/examColors.js
// Paleta del Examen (Kahoot) — CONSTANTES FIJAS, fuera del editor de estilos
// (decision Antonio: "el kahoo esta bien disenado, no necesita edicion"). Forma
// + color es accesibilidad (no depende solo del color), por eso es semantica
// fija, no branding editable. Ver design-system/student-portal/STYLE_GUIDE_STUDENT.md.
export const EXAM_ANSWERS = [
  { color: "#E74C3C", shape: "▲" }, // triangulo
  { color: "#3498DB", shape: "◆" }, // rombo
  { color: "#F1C40F", shape: "●", dark: true }, // circulo (texto oscuro)
  { color: "#2ECC71", shape: "■" }, // cuadrado
];

export const SECONDS_PER_QUESTION = 20;
